import { Helmet } from "react-helmet";
const SEO = ({
  prefix,
  suffix,
  path,
  image,
  keywords = "Entertainment services, Branding and Advertising, Automobile sales, Car import Nigeria, Tourist services, Business consultancy, Marketing campaigns, Car shipping Africa, Corporate branding, Digital marketing Nigeria, Travel assistance, Hotel reservations, Airport pickup, Brand strategy, CSR initiatives, Heroes of Tomorrow",
  description = "Concept Multi-Services Nig is a dynamic consultancy offering expertise in Entertainment & Culture, Branding & Advertising, Automobile Sales, and Tourist Services. We provide innovative solutions to elevate brands, streamline travel, and enhance business success. Contact us today!",
}) => {
  const seo = {
    description: description,
    url: `https://conceptmultiservicesnig.com${path}`,
    title: `${prefix ? prefix + " | " : ""}Concept Multi-Services Nig${
      suffix ? " - " + suffix : ""
    }`,
    image: image || "/og-image.jpeg",
    twitterUsername: "@conceptmultiservicesnig",
    keywords: keywords,
  };

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#000000" />
      <link rel="icon" href="/favicon.ico" />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/apple-touch-icon.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon-16x16.png"
      />
      <title>{seo.title}</title>
      <meta name="keywords" content={seo.keywords} />
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={seo.twitterUsername} />
      <meta name="twitter:site" content={seo.twitterUsername} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta name="robots" content="index, follow" />
    </Helmet>
  );
};

export default SEO;
